import * as Types from 'src/actions/investor-deck/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import InvestorDeck from 'src/entities/InvestorDeck';

export interface GetInvestorDeckAttempt extends Action {
  type: Types.GET_INVESTOR_DECK_ATTEMPT;
}

export interface GetInvestorDeckSuccess extends Action {
  type: Types.GET_INVESTOR_DECK_SUCCESS;
  payload: InvestorDeck;
}

export interface GetInvestorDeckFailure extends Action {
  type: Types.GET_INVESTOR_DECK_FAILURE;
}

export type GetInvestorDeckAction = GetInvestorDeckAttempt |
  GetInvestorDeckSuccess |
  GetInvestorDeckFailure;

export interface GetInvestorDeckThunk
  extends ThunkAction<Promise<GetInvestorDeckAction>, RootState, string> {
}

export const getInvestorDeckAttempt: ActionCreator<GetInvestorDeckAttempt> = () => (
  {
    type: Types.GET_INVESTOR_DECK_ATTEMPT
  }
);

export const getInvestorDeckSuccess: ActionCreator<GetInvestorDeckSuccess> = (
  investorDeck: InvestorDeck
) => ({
  type: Types.GET_INVESTOR_DECK_SUCCESS,
  payload: investorDeck
});

export const getInvestorDeckFailure: ActionCreator<GetInvestorDeckFailure> = () => ({
  type: Types.GET_INVESTOR_DECK_FAILURE
});

export const getInvestorDeck: ActionCreator<GetInvestorDeckThunk> = (
  userId: number
): GetInvestorDeckThunk => {
  return (dispatch: Dispatch<RootState>): Promise<GetInvestorDeckAction> => {
    dispatch(getInvestorDeckAttempt());
    return ApiClient.investorDeck.get(userId)
      .then((response: AxiosResponse<InvestorDeck>): GetInvestorDeckSuccess => {
        const investorDeck: InvestorDeck = new InvestorDeck(response.data);
        return dispatch(getInvestorDeckSuccess(investorDeck));
      }).catch((): GetInvestorDeckFailure => {
        return dispatch(getInvestorDeckFailure());
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/investor-deck/get/GetInvestorDeck.actions.tsx